var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 8.5714V12.8571M11.9999 16.7143V17.1428M2.15136 17.9648L8.92096 4.14354C10.1751 1.58293 13.8249 1.58293 15.0791 4.14354L21.8487 17.9648C22.1451 18.57 22.3813 19.2495 21.7774 19.7309C18.9375 21.9944 5.0626 21.9944 2.22269 19.7309C1.61788 19.2488 1.85181 18.5763 2.15136 17.9648Z",
    stroke: "currentColor",
    strokeWidth: 1.71429,
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round"
  })));
};

export { SvgError as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0xMS45OTk5IDguNTcxNFYxMi44NTcxTTExLjk5OTkgMTYuNzE0M1YxNy4xNDI4TTIuMTUxMzYgMTcuOTY0OEw4LjkyMDk2IDQuMTQzNTRDMTAuMTc1MSAxLjU4MjkzIDEzLjgyNDkgMS41ODI5MyAxNS4wNzkxIDQuMTQzNTRMMjEuODQ4NyAxNy45NjQ4QzIyLjE0NTEgMTguNTcgMjIuMzgxMyAxOS4yNDk1IDIxLjc3NzQgMTkuNzMwOUMxOC45Mzc1IDIxLjk5NDQgNS4wNjI2IDIxLjk5NDQgMi4yMjI2OSAxOS43MzA5QzEuNjE3ODggMTkuMjQ4OCAxLjg1MTgxIDE4LjU3NjMgMi4xNTEzNiAxNy45NjQ4WiIKICAgICAgICAgIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjEuNzE0MjkiIHZlY3Rvci1lZmZlY3Q9Im5vbi1zY2FsaW5nLXN0cm9rZSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPgo=";